export namespace ServiceClientKeys {
    export const DistributedTaskClient = "SERVICE_CLIENT_KEY_DISTRIBUTED_TASK_CLIENT";
    export const IdentitiesClient = "SERVICE_CLIENT_KEY_IDENTITIES_CLIENT";
}
